window.addEventListener('load', function () {
  // Check if the current page is a blog post
  if (this.location.pathname.includes('/blogs/')) {
    let start = document.querySelector('.nj-article-start');
    let end = document.querySelector('.nj-article-end');
    let main = document.querySelector('main');
    if (start && end) {
      // Wrap elements between start and end elements in article
      let article = document.createElement('article');
      let next = start.nextElementSibling;
      while (next && next !== end) {
        let nextSibling = next.nextElementSibling;
        article.appendChild(next);
        next = nextSibling;
      }

      // Create the parent divs
      let section = document.createElement('section');
      section.className = 'nj-article-section';
      let container = document.createElement('div');
      container.className = 'container';
      let flex = document.createElement('div');
      flex.className = 'flex';

      // Nest the elements
      flex.appendChild(article);
      container.appendChild(flex);
      section.appendChild(container);
      // Add the section class to the section element
      section.classList.add('nj-article-section', 'main-article');

      // Insert the container after the start element
      start.parentNode.insertBefore(section, start.nextSibling);

      // Insert the end element after the container
      start.parentNode.insertBefore(end, section.nextSibling);

      // Remove the start and end elements
      start.parentNode.removeChild(start);
      end.parentNode.removeChild(end);

      // Add the article class to the article element
      article.classList.add('nj-article');
    }

    let navLinks = [...document.querySelectorAll('.nj-article-section [data-nav]')].filter(
      (link) => link.dataset.nav && link.dataset.nav.trim() !== ''
    );
    if (navLinks.length > 0) {
      let divToAppendTo;
      if (document.querySelector('.article-table-of-contents-main-div') === null) {
        divToAppendTo = document.querySelector('.nj-article-section .authors-section');
      } else {
        divToAppendTo = document.querySelector('.article-table-of-contents-main-div');
      }
      let nav = document.createElement('nav');
      let navInner = document.createElement('div');
      nav.className = 'nj-article-nav';
      navInner.className = 'content';
      let ol = document.createElement('ol');
      let title = document.createElement('h2');
      title.textContent = 'In this Article';
      title.className = 'nj-article-nav-title';
      navInner.appendChild(title);
      let viewMore;
      if (navLinks.length > 3) {
        viewMore = document.createElement('button');
        let viewMoreSpan = document.createElement('span');
        viewMoreSpan.textContent = 'View all';
        viewMore.className = 'nj-article-nav-view-more';
        viewMore.addEventListener('click', function () {
          navInner.classList.toggle('expanded');
        });
        let viewMoreSvg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
        viewMoreSvg.setAttribute('width', '7');
        viewMoreSvg.setAttribute('height', '10');
        viewMoreSvg.setAttribute('viewBox', '0 0 7 10');
        viewMoreSvg.setAttribute('fill', 'none');
        viewMoreSvg.setAttribute('xmlns', 'http://www.w3.org/2000/svg');
        let path = document.createElementNS('http://www.w3.org/2000/svg', 'path');
        path.setAttribute(
          'd',
          'M0.945312 1.80021L4.14531 5.00021L0.945312 8.20021L1.94531 9.13321L6.14531 5.00021L1.94531 0.866211L0.945312 1.80021Z'
        );
        path.setAttribute('fill', '#DA765A');
        viewMoreSvg.appendChild(path);
        viewMore.appendChild(viewMoreSpan);
        viewMore.appendChild(viewMoreSvg);
      }

      navLinks.forEach((link) => {
        let li = document.createElement('li');
        let a = document.createElement('a');
        a.href = `#${link.dataset.nav}`;
        a.textContent = link.dataset.nav
          .split('-')
          .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
          .join(' ');
        a.className = 'j-scroll-to-article-block';
        a.setAttribute('data-nav-target', link.dataset.nav);
        a.addEventListener('click', function (e) {
          e.preventDefault();
          let target = document.querySelector(`.nj-article-section .flex article [data-nav="${link.dataset.nav}"]`);
          if (target) {
            $('html, body').animate(
              {
                scrollTop: $(target).offset().top - 120,
              },
              300
            );
          }
        });
        li.appendChild(a);
        ol.appendChild(li);
      });

      nav.appendChild(navInner);
      navInner.appendChild(ol);
      if (viewMore) {
        navInner.appendChild(viewMore);
      }

      if (divToAppendTo) {
        divToAppendTo.parentNode.insertBefore(nav, divToAppendTo.nextSibling);
      } else {
        document.querySelector('.nj-article-section.main-article .flex article').prepend(nav);
      }
    }
    main.classList.remove('opacity-0');
  }

  let mobileNav = document.querySelector('.rtnu-header__mobile');
  const observer = new MutationObserver(function (mutationsList) {
    for (const mutation of mutationsList) {
      if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
        // Class attribute has changed
        let psWidgetContainer = document.querySelector('#ps__widget_container');
        let gorgiasChatContainer = document.querySelector('#gorgias-chat-container');
        let boostProductBar = document.querySelector('#boost-product-bar');
        if (mutation.target.classList.contains('active')) {
          // Mobile nav is open
          psWidgetContainer?.classList.add('hidden');
          gorgiasChatContainer?.classList.add('hidden');
          boostProductBar?.classList.add('hidden');
          // You can add your specific logic here based on the new class list
        } else {
          psWidgetContainer?.classList.remove('hidden');
          gorgiasChatContainer?.classList.remove('hidden');
          boostProductBar?.classList.remove('hidden');
        }
        // psWidgetContainer.classList.add('hidden');
        // You can add your specific logic here based on the new class list
      }
    }
  });
  let retryWidget = 120;

  var waitForWidgets = function (callback) {
    if (retryWidget > 0) {
      if (typeof $ != 'undefined') {
        if (
          $('#psWidgetContainer').length > 0 &&
          $('#gorgias-chat-container').length > 0 &&
          $('#boost-product-bar').length > 0 &&
          $(`button[part='acsb-trigger']`).length > 0
        ) {
          callback();
        } else {
          retryWidget = retryWidget - 1;
          setTimeout(function () {
            waitForWidgets(callback);
          }, 100);
        }
      } else {
        retryWidget = retryWidget - 1;
        setTimeout(function () {
          waitForWidgets(callback);
        }, 100);
      }
    }
  };

  if (mobileNav) {
    waitForWidgets(() => {
      observer.observe(mobileNav, {
        attributes: true, // Watch for attribute changes
        attributeFilter: ['class'], // Only watch the class attribute
      });
    });
  }

  const faqSection = document.querySelector('.faq-section');
  const sectionIdPrefix = 'shopify-section-';
  const faqSectionId = faqSection ? faqSection.id.split(sectionIdPrefix)[1] : null;
  const faqTriggerWrapper = document.querySelector('[data-faq-trigger-wrapper]');
  let requestFAQ = fetch(window.location.pathname + `?sections=${faqSectionId}`).then((res) => res.json());
  requestFAQ
    .then((data) => {
      const faqContent = data[faqSectionId];
      const faqContainer = document.querySelector('.product__hero-faqs-modal-content');
      faqContainer.innerHTML = faqContent;
      const accordionItems = faqContainer.querySelectorAll('.rtnu__accordion-item');
      accordionItems.forEach((item) => {
        const toggle = item.querySelector('.rtnu__accordion-item-toggle');
        toggle.addEventListener('click', function () {
          item.classList.toggle('is-open');
        });
      });
      if (faqTriggerWrapper) {
        faqTriggerWrapper.style.display = 'block';
      }
    })
    .catch((error) => {
      console.error('Error fetching FAQ section:', error);
    });

  const okendoReviewData = this.window.okendoProduct;
  if (okendoReviewData) {
    const starRatingsContainer = document.querySelector('[data-star-ratings]');
    if (starRatingsContainer) {
      const filledStarContainer = starRatingsContainer.querySelector('.oke-stars-foreground--custom');
      filledStarContainer.style.width = `${(okendoReviewData.reviewAverageValue / 5) * 100}%`;
      const reviewCountElement = document.querySelector('[data-review-count]');
      reviewCountElement.textContent = okendoReviewData.reviewCount || '0';
      const starA11yText = filledStarContainer.querySelector('.oke-a11yText');
      starA11yText.textContent = `${okendoReviewData.reviewAverageValue} out of 5 stars based on ${okendoReviewData.reviewCount} reviews`;
    }
  }
});
